import { useState, useEffect, Fragment } from 'react'
import apiFetch from '@wordpress/api-fetch'
import { useSmartProp } from '@smartfire/js-block-engine'
import { PanelBody, PanelRow, SelectControl, Button } from '@wordpress/components'

const Inspector = () => {
    const [suggestions, setSuggestions] = useSmartProp('suggestions')
    const [complete, setComplete] = useSmartProp('complete')
    const [pages, setPages] = useState([])

    const LIMIT_SUGGESTIONS = 4

    useEffect(() => {
        apiFetch({ path: 'wp/v2/pages?per_page=-1' }).then((data) => {
            let pagesList = data.map((el) => {
                return {
                    value: el.link,
                    label: el.title.rendered,
                }
            })
            setPages(pagesList)
        })
    }, [])

    const handleChange = (page, index) => {
        const item = pages.find((p) => p.value === page)
        const suggestionsCopy = [...suggestions]
        suggestionsCopy[index] = item

        setSuggestions(suggestionsCopy)
    }

    const addElement = () => {
        setSuggestions([
            ...suggestions,
            {
                label: '',
                value: '',
            },
        ])
    }

    const removeElement = (index) => {
        setSuggestions([...suggestions.slice(0, index), ...suggestions.slice(index + 1)])
    }

    return (
        <>
            <PanelBody title={'Suggestions'}>
                {suggestions.map((_, index) => (
                    <Fragment key={index}>
                        <PanelRow>
                            <SelectControl
                                label="Page"
                                value={suggestions[index].value}
                                onChange={(item) => handleChange(item, index)}
                                options={pages}
                            />
                        </PanelRow>
                        {suggestions.length > 1 && (
                            <Button variant="secondary" onClick={() => removeElement(index)}>
                                Supprimer
                            </Button>
                        )}
                    </Fragment>
                ))}
                {suggestions.length < LIMIT_SUGGESTIONS && (
                    <PanelRow>
                        <Button variant="primary" onClick={addElement}>
                            Ajouter un élément
                        </Button>
                    </PanelRow>
                )}
            </PanelBody>
            <PanelBody title={'Sélection complète'}>
                <PanelRow>
                    <SelectControl label="Page" value={complete} onChange={setComplete} options={pages} />
                </PanelRow>
            </PanelBody>
        </>
    )
}

export default Inspector
